const PRIVATE_LAN_HOST_PATTERNS = [
  /^192\.168\.\d{1,3}\.\d{1,3}$/,
  /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,
];

const normalizeValue = (value) => String(value || '').trim();

const isLoopbackHost = (hostname) => {
  const normalized = normalizeValue(hostname).toLowerCase();
  return normalized === 'localhost' || normalized === '127.0.0.1';
};

const isPrivateLanHost = (hostname) => {
  const normalized = normalizeValue(hostname);
  if (!normalized) {
    return false;
  }
  if (isLoopbackHost(normalized)) {
    return true;
  }
  if (PRIVATE_LAN_HOST_PATTERNS.some((pattern) => pattern.test(normalized))) {
    return true;
  }
  const match = normalized.match(/^172\.(\d{1,3})\.\d{1,3}\.\d{1,3}$/);
  return Boolean(match && Number(match[1]) >= 16 && Number(match[1]) <= 31);
};

const getBrowserHostname = (browserLocation) => {
  if (!browserLocation || typeof browserLocation !== 'object') {
    return '';
  }
  return normalizeValue(browserLocation.hostname);
};

const parseHostnameFromUrl = (url) => {
  const normalized = normalizeValue(url);
  if (!normalized) {
    return '';
  }
  try {
    return new URL(normalized).hostname;
  } catch {
    return '';
  }
};

export const resolveApiBaseUrl = ({
  environment = process.env.NODE_ENV || 'development',
  configuredApiUrl = process.env.REACT_APP_API_URL,
  browserLocation = typeof window !== 'undefined' ? window.location : null,
  devPort = '5050',
  fallbackDevUrl = `http://localhost:${devPort}`,
  fallbackProductionUrl = 'https://forza-backend-ox31.onrender.com'
} = {}) => {
  const configured = normalizeValue(configuredApiUrl);

  if (environment !== 'development') {
    return configured || fallbackProductionUrl;
  }

  const configuredHost = parseHostnameFromUrl(configured);
  if (configured && configuredHost && !isLoopbackHost(configuredHost)) {
    return configured;
  }

  const browserHostname = getBrowserHostname(browserLocation);
  if (isPrivateLanHost(browserHostname)) {
    return `http://${browserHostname}:${devPort}`;
  }

  return configured || fallbackDevUrl;
};

export { isPrivateLanHost };
